import { formatPrice } from "@/utils/format-price";
import { transactionAmountTheme } from "./theme";

export default function TransactionAmount({ amount, kind }) {
  return (
    <span className={transactionAmountTheme[kind].text}>
      {formatPrice(amount)}
    </span>
  );
}
